import antdEsUS from 'antd/es/locale/es_ES';
import esMsg from "../locales/es_US.json";

const EsLang = {
  antd: antdEsUS,
  locale: 'es-US',
  messages: {
    ...esMsg
  },
};
export default EsLang;
